var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.26 200.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "solvent-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.34,158.15c0-38-20.23-53.78-47.43-74.21C91.3,78.92,76.2,69.27,77.09,60c2.12-22.2,41.42-7.9,49.13-4.27V27.65C91.67,13.94,47.09,21.31,45.77,60.78c-.37,12.91,8.08,24.7,19.44,33.77a63,63,0,0,0-17.38,9.61C29.29,118.45,18.57,141.77,21.58,166c3.75,31.42,29.84,55.48,61.59,55.48,34.39,0,62.17-28.32,62.17-63.37ZM76.57,105.33c23.4,17.34,40,29.29,40,52.82,0,18.88-14.94,34.09-33.43,34.09-18.33,0-33.44-15.21-33.44-34.09,0-30.47,28.53-32,26.84-52.82Z",
    transform: "translate(-21.08 -21.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolventIcon);
export default __webpack_public_path__ + "static/media/solvent-icon.be29c698d260963a2b1f0f2f29ff9550.svg";
export { ForwardRef as ReactComponent };